
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./homepage.css";
import Contact from "./Contact/Contact"; // adjust path if needed
import { Link } from "react-router-dom"; // already imported useNavigate, optional
import logo from "../Components/Assets/logo.png";
import banner1 from "../Components/Assets/empowering.png";
import banner2 from "../Components/Assets/health.png";
import banner3 from "../Components/Assets/image.png";

import DonateModal from "./DonatePage"

const slides = [
  {
    id: 1,
    title: "Empowering Rural Youth",
    description: "Creating opportunities through education and skill development in underserved communities.",
    image: banner1,
    cta: "Join Our Mission",
  },
  {
    id: 2,
    title: "Health & Wellness Initiatives",
    description: "Delivering healthcare awareness and wellness camps in remote villages.",
    image: banner2,
    cta: "Support Now",
  },
  {
    id: 3,
    title: "Women Empowerment Programs",
    description: "Helping women gain financial independence through vocational training.",
    image: banner3,
    cta: "Get Involved",
  },
];

const objectives = [
  {
    icon: "📘",
    title: "Education, Knowledge & Skill Development",
    desc: "Schools, libraries, e-resources, mentorship, PDP, competitive exams, scholarships, and training programs.",
    route: "/library"
  },
  {
    icon: "❤️",
    title: "Healthcare, Fitness & Wellness",
    desc: "Health camps, mobile units, yoga, fitness, insurance, reiki, astrology, and spiritual guidance.",
    route: "/counselling"
  },
  {
    icon: "👩‍🎓",
    title: "Women & Girl Child Empowerment",
    desc: "Vocational training, entrepreneurship support, and marriage/rehabilitation assistance.",
    route: "/membership"
  },
  {
    icon: "👵👶",
    title: "Elderly & Orphan Welfare",
    desc: "Old age homes, orphanages, shelters, and basic amenity programs for dignity and care.",
    route:  "/membership"
  },
  {
    icon: "🐄",
    title: "Animal Welfare & Cow Protection",
    desc: "Managing gaushalas and promoting eco-sustainable, cow-based agriculture.",
    route:  "/membership"
  },
  {
    icon: "🕌",
    title: "Religious & Cultural Harmony",
    desc: "Support for temples, community kitchens, festivals, and interfaith unity events.",
    route: "/membership"
  },
  {
    icon: "💰",
    title: "Microfinance & Economic Empowerment",
    desc: "Microloans, SHG support, financial literacy and entrepreneurship training.",
    route: "/contact"
  },
  {
    icon: "🚰",
    title: "Public Welfare & Infrastructure",
    desc: "Sanitation, clean water, disaster response, and basic hygiene projects.",
    route:  "/membership"
  },
];


const PromoSlider = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 700,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
const [showDonateModal, setShowDonateModal] = useState(false);
  return (
    <div className="homepage">

     <div className="marquee-banner">
  <Link to="/membership" className="marquee-text">
    <span>
      🎉 Become a Member for FREE! FREE! Click Here to Join Now →
      🎉 Become a Member for FREE! FREE! Click Here to Join Now →
    </span>
  </Link>
</div>


      <div className="promo-slider">
        <Slider {...settings}>
          {slides.map((slide) => (
            <div key={slide.id} className="slide">
              <div className="slide-content">
                <div className="slide-text">
                  <h4>Navveer Foundation</h4>
                  <h2>{slide.title}</h2>
                  <p>{slide.description}</p>
                  <button onClick={() => navigate("/membership")}>
                    {slide.cta}
                  </button>
                </div>
                <img src={slide.image} alt={slide.title} />
              </div>
            </div>
          ))}
        </Slider>
      </div>

    

<section className="about-navveer" data-aos="fade-up">
  <div className="about-content">
    <div className="about-text">
      <h2>About Us – What We Do</h2>
      <p>
        We are a not-for-profit organization committed to social transformation through education,
        empowerment, healthcare, and holistic development. Our mission is to uplift communities by
        providing access to essential services and opportunities.
      </p>
      <p>
        We work across education, women empowerment, healthcare, spiritual wellness, animal protection,
        economic growth, and infrastructure – building an inclusive, compassionate, and empowered society.
      </p>
      <button className="donate-button" ><Link to="/donate">Contribute</Link></button>

    </div>
    <div className="about-image">
      <img src={logo} alt="Navveer Logo" />
    </div>
  </div>
</section>

      <section className="objectives-grid">
        {objectives.map((item, index) => (
          <div
            className="objective-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="icon">{item.icon}</div>
            <h3><strong>{item.title}</strong></h3>
            <p>{item.desc}</p>
            <button onClick={() => navigate(item.route)}>Learn More</button>
          </div>
        ))}
      </section>
      <Contact />
{showDonateModal && <DonateModal onClose={() => setShowDonateModal(false)} />}

    </div>
    
  );
  

};

export default PromoSlider;
